import React from "react";
import { useState, useEffect } from "react";
import useQuery from "../../hook/useQuery";
import CardCentral from "../../components/Card";
import Typography from "@material-ui/core/Typography";
import useStyles from "./style";
import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import { Button, Link } from "@material-ui/core";
import { Link as RouterLink, useHistory, useLocation } from "react-router-dom";

import UsuarioService from "../../services/usuarioService";
import { useAuth } from "../../auth/ProvideAuth";

const Login = (props) => {
  const location = useLocation();
  const is403 = location.state ? location.state.is403 : null;
  const redirect_rel = location.state ? location.state.redirect_rel : null;

  const auth = useAuth();

  const history = useHistory();
  const classes = useStyles();

  const query = useQuery();

  const [error, setErro] = useState({ isError: false, erroMsg: "" });
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");

  const entrar = async (event) => {
    event.preventDefault();
    try {
      let res = await UsuarioService.login(email, senha);

      auth.signin(() => {
        if (redirect_rel) {
          history.goBack();
        } else {
          history.push("/");
        }
      });
    } catch (e) {
      setErro({ isError: true, erroMsg: "Usuário e/ou senha inválidos" });
    }
  };

  if (auth.user != null) {
    auth.signout(() => {});
  }

  return (
    <CardCentral>
      <>
        <Typography
          component={"span"}
          className={classes.header}
          variant="h5"
          gutterBottom>
          Entrar
        </Typography>
        <form className={classes.form} onSubmit={entrar}>
          <div className={classes.margin}>
            <TextField
              error={error.isError}
              size="small"
              label="Email"
              variant="outlined"
              type="email"
              fullWidth={true}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className={classes.margin}>
            <TextField
              error={error.isError}
              size="small"
              label="Senha"
              variant="outlined"
              type="password"
              fullWidth={true}
              helperText={error.erroMsg}
              value={senha}
              onChange={(e) => setSenha(e.target.value)}
            />
          </div>
          <div className={`${classes.margin} ${classes.subForm}`}>
            <FormControlLabel
              control={
                <Switch
                  size="small"
                  color="primary" /*checked={state.gilad} onChange={handleChange}*/
                />
              }
              label="Lembrar-me"
              className={classes.switch}
            />
            <Button type="submit" variant="contained" color="primary">
              Entrar
            </Button>
          </div>
        </form>
        <div className={classes.footer}>
          <Typography
            component={"p"}
            variant="body2"
            className={classes.margin}>
            <Link component={RouterLink} to="/redefinirSenha" color="secondary">
              Esqueceu sua senha?
            </Link>
          </Typography>
          {/* TODO: CRIAR TELA CADASTRO */}
          {/* <Typography component={"p"} variant="body2" style={{marginTop:"16px"}}>
            <Link href="/singup" color="secondary" className={classes.margin}>
              Ainda não é membro? Cadastre-se!
            </Link>
          </Typography> */}
        </div>
      </>
    </CardCentral>
  );
};

export default Login;
